import { createRouter, createWebHashHistory } from 'vue-router';
import HomePage from '../views/home/HomePage.vue';
import OrganizePage from '../views/organize/OrganizePage.vue';
import ActivityPage from '../views/activity/ActivityPage.vue';
import ActivityDetailPage from '../views/activity/ActivityDetailPage.vue';
import MinePage from '../views/mine/MinePage.vue';
import OrgTransferDetailPage from '../views/organize/OrgTransferDetailPage.vue';
import MeetingListPage from '../views/organize/MeetingListPage.vue';
import MeetingDetailPage from '../views/organize/MeetingDetailPage.vue';
import MeetingReportDetailPage from '../views/organize/MeetingReportDetailPage.vue';
import MicroWishPage from '../views/organize/MicroWishPage.vue';
import MicroWishDetailPage from '../views/organize/MicroWishDetailPage.vue';
import PartyFeePayPage from '../views/organize/PartyFeePayPage.vue';
import MyInfoPage from '../views/mine/MyInfoPage.vue';
import QuestionFeedbackPage from '../views/mine/QuestionFeedbackPage.vue';
import AboutPage from '../views/mine/AboutPage.vue';
import ManualPage from '../views/mine/ManualPage.vue';
import LoginPage from '../views/login/LoginPage.vue';
import ArticleDetailPage from '../views/home/ArticleDetailPage.vue';
import MessagePage from '../views/home/MessagePage.vue';
import MessageDetailPage from '../views/home/MessageDetailPage.vue';
import { getToken } from '../utils/auth';

// 定义路由
const routes = [
  // 根路径重定向到/home，使首页为默认页面
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { title: '登录' },
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage,
    meta: { title: '首页' },
  },
  {
    path: '/home/article/detail',
    name: 'ArticleDetailPage',
    component: ArticleDetailPage,
    meta: { title: '文章详情' },
  },
  {
    path: '/home/message',
    name: 'MessagePage',
    component: MessagePage,
    meta: { title: '消息通知' },
  },
  {
    path: '/home/message/detail',
    name: 'MessageDetailPage',
    component: MessageDetailPage,
    meta: { title: '消息详情' },
  },
  {
    path: '/organize',
    name: 'OrganizePage',
    component: OrganizePage,
    meta: { title: '组织生活' },
  },
  {
    path: '/activity',
    name: 'ActivityPage',
    component: ActivityPage,
    meta: { title: '活动' },
  },
  {
    path: '/activity/detail',
    name: 'ActivityDetailPage',
    component: ActivityDetailPage,
    meta: { title: '活动详情' },
  },
  {
    path: '/organize/party-fee',
    name: 'PartyFeePayPage',
    component: PartyFeePayPage,
    meta: { title: '党费缴纳' },
  },
  {
    path: '/organize/transfer',
    redirect: '/organize/transfer/detail'
  },
  {
    path: '/organize/transfer/detail',
    name: 'OrgTransferDetailPage',
    component: OrgTransferDetailPage,
    meta: { title: '转接详情' },
  },
  {
    path: '/organize/meeting',
    name: 'MeetingListPage',
    component: MeetingListPage,
    meta: { title: '三会一课' },
  },
  {
    path: '/organize/meeting/detail',
    name: 'MeetingDetailPage',
    component: MeetingDetailPage,
    meta: { title: '会议详情' },
  },
  {
    path: '/organize/meeting/report',
    name: 'MeetingReportDetailPage',
    component: MeetingReportDetailPage,
    meta: { title: '会议纪要' },
  },
  {
    path: '/organize/microwish',
    name: 'MicroWishPage',
    component: MicroWishPage,
    meta: { title: '微心愿' },
  },
  {
    path: '/organize/microwish/detail',
    name: 'MicroWishDetailPage',
    component: MicroWishDetailPage,
    meta: { title: '祝福记录' },
  },
  {
    path: '/mine',
    name: 'MinePage',
    component: MinePage,
    meta: { title: '我的' },
  },
  {
    path: '/mine/info',
    name: 'MyInfoPage',
    component: MyInfoPage,
    meta: { title: '我的信息' },
  },
  {
    path: '/mine/question-feedback',
    name: 'QuestionFeedbackPage',
    component: QuestionFeedbackPage,
    meta: { title: '问题反馈' },
  },
  {
    path: '/mine/about',
    name: 'AboutPage',
    component: AboutPage,
    meta: { title: '关于我们' },
  },
  {
    path: '/mine/manual',
    name: 'ManualPage',
    component: ManualPage,
    meta: { title: '说明手册' },
  },
];

// 创建路由实例
const router = createRouter({
  // Hash history avoids server-side rewrite requirements in subdirectory deployments.
  history: createWebHashHistory(),
  routes,
});

// 设置全局标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '天翼党建VR版';
  const token = getToken();

  if (token && to.path === '/login') {
    next('/home');
    return;
  }

  if (!token && to.path !== '/login') {
    next('/login');
    return;
  }

  next();
});

// 导出路由
export default router;
